import React from "react";
import { Article } from "@randajan/jet-react/dom/article";

import "./Legal.scss";

const LinkOut = (props)=>{
    return <a {...props} target="_blank"></a>
}

export const Legal = (props)=>{
    const { content } = props;

    return (
        <div className="Legal">
            <Article level={0} src={content} overrides={{a:LinkOut}}/>
        </div>
    );
};
